import { login } from '~constants';
import SkopeiConnectService from '~services/skopeiConnectService';

import { ChallengeRequest } from './interfaces/challengeRequest';
import { ChallengeResponse } from './interfaces/challengeResponse';
import { SignInStartRequest } from './interfaces/signInStartRequest';
import { TokenResponseType } from './interfaces/tokenResponseType';

/**
 * Some important resources:
 * https://learn.microsoft.com/en-us/entra/identity-platform/v2-oauth2-auth-code-flow#refresh-the-access-token
 */
class SignInService extends SkopeiConnectService {
	private CLIENT_ID = import.meta.env.VITE_SKOPEI_OIDC_CLIENT_ID;
	private BASE_URL = import.meta.env.VITE_SKOPEI_OIDC_AUTHORITY_URL_V2;

	async signInStart(params: { email: string }): Promise<ChallengeResponse> {
		const body: SignInStartRequest = {
			username: params.email, // Email is considered the username
			client_id: this.CLIENT_ID,
			challenge_type: 'oob redirect',
		};

		const response = await this.client.post(login.urlAuthInitiate, body, {
			baseURL: this.BASE_URL,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		});

		return response.data;
	}

	async signInChallenge(params: { continuationToken: string }): Promise<ChallengeResponse> {
		const body: ChallengeRequest = {
			continuation_token: params.continuationToken,
			client_id: this.CLIENT_ID,
			challenge_type: 'oob redirect',
		};

		const response = await this.client.post<ChallengeResponse>(login.urlAuthChallenge, body, {
			baseURL: this.BASE_URL,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		});

		return response.data;
	}

	async signInTokenRequest(params: {
		continuationToken: string;
		oob: string;
	}): Promise<TokenResponseType> {
		const body = {
			client_id: this.CLIENT_ID,
			scope: login.signInScopes,
			continuation_token: params.continuationToken,
			oob: params.oob,
			grant_type: 'oob',
			challenge_type: 'oob redirect',
		};

		const response = await this.client.post<TokenResponseType>(login.urlAuthToken, body, {
			baseURL: this.BASE_URL,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		});

		return response.data;
	}
}

export default SignInService;
